import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useTranslation } from "react-i18next";

export const useLanguageSelector = () => {
    const { i18n } = useTranslation();

    const handleLangChange = (value: string) => {
        i18n.changeLanguage(value);
        localStorage.setItem("lang", value);
    };

    return { handleLangChange };
};

const LanguageSelector = () => {
    const { t, i18n } = useTranslation();
    const { handleLangChange } = useLanguageSelector();

    const handleOnChange = (event: SelectChangeEvent<string>) => {
        handleLangChange(event.target.value as string);
    };

    return (
        <FormControl fullWidth size="small" className="">
            <InputLabel id="lang-selector-label">{t("language")}</InputLabel>
            <Select
                labelId="lang-selector-label"
                id="lang-selector"
                label={t("language")}
                onChange={handleOnChange}
                value={i18n.language}
            >
                <MenuItem value={"en"}>English</MenuItem>
                <MenuItem value={"es"}>Español</MenuItem>
                <MenuItem value={"tr"}>Türkçe</MenuItem>
                <MenuItem value={"de"}>Deutsch</MenuItem>
                <MenuItem value={"ar"}>العربية</MenuItem>
            </Select>
        </FormControl>
    );
};

export default LanguageSelector;
